import { getMobileFontSizeClassName } from '../build-global-css';
import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getStyleProp } from './css-property-utils';
export const injectMobileFontSizeClass = (el, props) => {
    const fontSize = getStyleProp(el, 'font-size', props.css);
    if (fontSize) {
        const mobileFontSize = toMobileFontSize(fontSize);
        el.addClass(getMobileFontSizeClassName(mobileFontSize));
    }
};
//# sourceMappingURL=inject-mobile-font-size-class.js.map